import { render, staticRenderFns } from "./NsEmailSimple.vue?vue&type=template&id=59a75552&scoped=true&"
import script from "./NsEmailSimple.vue?vue&type=script&lang=js&"
export * from "./NsEmailSimple.vue?vue&type=script&lang=js&"
import style0 from "./NsEmailSimple.vue?vue&type=style&index=0&id=59a75552&lang=scss&scoped=true&"
import style1 from "./NsEmailSimple.vue?vue&type=style&index=1&lang=scss&module=true&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style1.locals || style1)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./NsEmailSimple.vue?vue&type=style&index=1&lang=scss&module=true&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./NsEmailSimple.vue?vue&type=style&index=1&lang=scss&module=true&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js").rerender("59a75552")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "59a75552",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59a75552')) {
      api.createRecord('59a75552', component.options)
    } else {
      api.reload('59a75552', component.options)
    }
    module.hot.accept("./NsEmailSimple.vue?vue&type=template&id=59a75552&scoped=true&", function () {
      api.rerender('59a75552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsEmailSimple.vue"
export default component.exports